import { Component, Input, EventEmitter, Output, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { InteractivityEditorService } from '../../services/interactivity-editor.service';

@Component({
	selector: 'timepoint',
	templateUrl: './timepoint.component.html',
	styleUrls: ['./timepoint.component.scss']
})

export class TimepointComponent implements OnInit, OnChanges {

	@Input() tooltip: 'left' | 'right' | 'hide';
	@Input() label: string;
	@Input() maxTime: number;
	@Input() timepoint: string;
	@Input() widgetConfig: any;
	@Input() dragger: 'keyframe' | 'chapter' | 'none';
	@Input() offsetDifference: number;
	@Input() dragging: boolean;
	@Input() selected: boolean;
	@Output() onTimepointChange: EventEmitter<string> = new EventEmitter<string>();
	@Output() onLabelChange: EventEmitter<string> = new EventEmitter<string>();
	@Output() onEdit: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() onUpdateIgnoreShowChange: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() onUpdateIgnoreHideChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	timepointControl = new UntypedFormControl();
	labelControl = new UntypedFormControl();
	editMode = false;
	obeyTimelineShow = true;
	obeyTimelineHide = true;

	constructor(public interactivityEditorService: InteractivityEditorService) {
		this.obeyTimelineHide = true;
		this.obeyTimelineShow = true;
	}

	ngOnInit() {
		this.update();
		if (this.widgetConfig) {
			this.obeyTimelineShow = this.widgetConfig.ignoreTimelineShow === 'false';
			this.obeyTimelineHide = this.widgetConfig.ignoreTimelineHide === 'false';
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.timepoint && changes.timepoint.currentValue && !changes.timepoint.firstChange ||
			changes.label && changes.label.currentValue && !changes.label.firstChange) {
			this.update();
		}
		if (changes.widgetConfig && changes.widgetConfig.currentValue &&
			(changes.widgetConfig.currentValue.ignoreTimelineHide || changes.widgetConfig.currentValue.ignoreTimelineShow)
		) {
			this.obeyTimelineShow = this.widgetConfig.ignoreTimelineShow === 'false';
			this.obeyTimelineHide = this.widgetConfig.ignoreTimelineHide === 'false';
		}
	}

	update() {
		if ((typeof this.timepoint === 'string' && this.timepoint.indexOf('%') < 0) ||
			typeof this.timepoint === 'number') {
			this.timepointControl.setValue(this.timepoint);
		} else {
			this.timepointControl.reset();
		}

		if (this.label) {
			this.labelControl.setValue(this.label);
		}
	}

	changeTimepoint(timepoint: any) {
		if (timepoint || timepoint === 0) {
			this.onTimepointChange.emit(timepoint);
		} else {
			return;
		}
	}

	onLabelInputChange(ev: Event, newLabel: string) {
		ev.stopPropagation();
		ev.preventDefault();
		this.onLabelChange.emit(newLabel);
	}

	editTimepoint(editing: boolean) {
		if (!editing) {
			setTimeout(() => {
				this.editMode = editing;
			}, 250);
		} else {
			this.editMode = editing;
		}

		this.onEdit.emit(editing);
	}

	onInputMousedown(event: MouseEvent) {
		event.stopPropagation();
	}

	onUpdateIgnoreShow(value: boolean) {
		value = !value;
		this.onUpdateIgnoreShowChange.emit(value);
		this.editMode = true;
	}

	onUpdateIgnoreHide(value: boolean) {
		value = !value;
		this.onUpdateIgnoreHideChange.emit(value);
		this.editMode = true;
	}

}
